import { View, Text } from "react-native";
import { Button, PopOver } from "../../components";
import { Employment } from "../types";

export const EmploymentCannotBeChangedWarningModal = ({
  isModalVisible,
  setIsModalVisible,
}: {
  isModalVisible: boolean;
  setIsModalVisible: (value: boolean) => void;
}) => (
  <PopOver visible={isModalVisible} onDismiss={() => setIsModalVisible(false)} size="md">
    <View className="bg-white rounded-lg w-full" testID="employment-cannot-be-changed-modal">
      <Text className="text-regular-tight font-700 text-ink-darkest">Employment type cannot be changed.</Text>
      <Text className="text-regular-normal text-ink mt-4 mb-4">
        You must have more than one employment/job to assign it as secondary employment.
      </Text>
      <View className="flex-row justify-end">
        <Button size="small" mode="secondary" onPress={() => setIsModalVisible(false)}>
          Okay
        </Button>
      </View>
    </View>
  </PopOver>
);

export const WorkingLocationAffectSectionWarningModal = ({
  isModalVisible,
  onCancel,
  onConfirm,
}: {
  isModalVisible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) => (
  <PopOver visible={isModalVisible} onDismiss={onCancel} size="md">
    <View className="bg-white rounded-lg w-full" testID="employment-cannot-be-changed-modal">
      <Text className="text-regular-tight font-700 text-ink-darkest">
        Your working location may affect section affiliation.
      </Text>
      <Text className="text-regular-normal text-ink mt-4 mb-4">
        Your primary job determines which section you belong to. Selecting a remote or regional working location will align your
        section affiliation with the PGA section corresponding to your home address. Selecting on-site will align it with your
        employer's address. To adjust this affiliation, please contact your local section office.
      </Text>
      <View className="flex-row justify-end gap-3 items-center">
        <Button size="small" mode="text" onPress={onCancel}>
          Cancel
        </Button>
        <Button size="small" mode="secondary" onPress={onConfirm}>
          Confirm
        </Button>
      </View>
    </View>
  </PopOver>
);

export const ChangePrimaryEmploymentWarningModal = ({
  isModalVisible,
  setIsModalVisible,
  primaryEmployment,
  setPrimaryEmployment,
}: {
  isModalVisible: boolean;
  setIsModalVisible: (value: boolean) => void;
  primaryEmployment?: Employment;
  setPrimaryEmployment: () => void;
}) => {
  const onDismiss = () => setIsModalVisible(false);
  return (
    <PopOver visible={isModalVisible} onDismiss={onDismiss} size="md">
      <View testID="change-primary-employment-modal">
        <Text className="text-regular-tight font-700 text-ink-darkest mb-4">
          Are you sure you wish to change your primary employment?
        </Text>
        <Text className="text-regular-normal text-ink mb-4">
          Your primary employment is currently {primaryEmployment?.title} at {primaryEmployment?.facility.name}.
        </Text>
        <View className="flex-row justify-end">
          <Button size="small" onPress={onDismiss}>
            Cancel
          </Button>
          <Button
            size="small"
            className="ml-2"
            mode="secondary"
            onPress={() => {
              setPrimaryEmployment();
              setIsModalVisible(false);
            }}
          >
            Change Primary
          </Button>
        </View>
      </View>
    </PopOver>
  );
};
